// @avantia common-code
import { Policy } from '../types/policyTypes';
import { createMockPolicy } from './shared';

export const label = 'Buildings - Joint Policy Holders';

export const policy: Policy = createMockPolicy({
  policyNumber: 'B12/11000005',
  policyDetailsId: '110000051001',
  coverType: 'Buildings',
  accidentalDamageLevel: { Buildings: 'Basic', Contents: 'None' },
  additionalPolicyHolders: [
    { title: 'Mr', dateOfBirth: '1964-04-16T00:00:00', forename: 'test', surname: 'jhone' },
    { title: 'Mrs', dateOfBirth: '1969-08-22T00:00:00', forename: 'test', surname: 'jhtwo' }
  ]
});
